'use client';

import { useSession } from '@shared/auth';
import { Sunburst } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { cn } from '../../shadcn';
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';

type UserIdentityPanelProps = {
  namespace: string;
  playerNr?: number;
  showStatusBadge?: boolean;
  bannerBackgroundUrl?: string;
};

function UserIdentityPanel({ namespace, showStatusBadge, bannerBackgroundUrl }: UserIdentityPanelProps) {
  const { session } = useSession();

  const fullName = session?.profile?.firstName + ' ' + session?.profile?.lastName;
  const playerNr = session?.profile?.nr;
  const t = useTranslations(namespace);
  return (
    <div className="flex flex-col items-center gap-2 w-full pb-3">
      <div className="relative w-full flex justify-center">
        <div
          aria-hidden
          data-testid="user-identity-banner"
          className={cn('w-full h-20 rounded-lg', !bannerBackgroundUrl && 'bg-container-accent')}
          style={
            bannerBackgroundUrl
              ? {
                  backgroundImage: `url("${bannerBackgroundUrl}")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }
              : undefined
          }
        ></div>
        <ProfileAvatar className="absolute z-10 top-1/2" data-track-name="Avatar" data-track-privacy="Mask" />
      </div>
      <p className="text-foreground mt-14 paragraph-explanatory">{t('welcome_message')}</p>
      <div className="relative px-5">
        <h3 className="text-foreground" data-testid="full-name" data-track-privacy="Mask">
          {fullName}
        </h3>
        {showStatusBadge && <Sunburst size="extra-small" className="absolute right-0 top-0 text-accent-green"></Sunburst>}
      </div>
      {playerNr && (
        <p className="text-foreground-secondary paragraph-footnote" data-testid="player-id">
          {t('player_id', { nr: playerNr })}
        </p>
      )}
    </div>
  );
}

export { UserIdentityPanel };
